export const ITEMS_PER_PAGE_DEFAULT = {
    l: 3,
    m: 2,
    s: 1,
    xl: 4,
};
//# sourceMappingURL=constant.js.map